export default {
  setWallet(state, wallet) {
    state.wallet = wallet
  }
}
